var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremium({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.999,
    height: 18.999,
    viewBox: "0 0 18.999 18.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-premium-3248543",
    transform: "translate(-37.486 -37.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12275",
    "data-name": "Path 12275",
    d: "M56.475,305.164c0-.012,0-.024,0-.036a.619.619,0,0,0,.006-.062.633.633,0,0,0-.011-.109s0-.008,0-.012a.623.623,0,0,0-.065-.175c0-.006,0-.012-.006-.017l-2.533-4.433c0-.005-.008-.01-.011-.015h0a.627.627,0,0,0-.082-.107l-.011-.013a.634.634,0,0,0-.1-.084l-.015-.008c-.012-.007-.024-.012-.036-.019h0a.626.626,0,0,0-.1-.044l-.041-.011h0a.627.627,0,0,0-.129-.017l-.017,0H40.653l-.017,0a.626.626,0,0,0-.129.017l-.041.011a.621.621,0,0,0-.1.044c-.012.006-.025.011-.036.019l-.015.008h0a.631.631,0,0,0-.1.084l-.011.013a.625.625,0,0,0-.082.107c0,.005-.008.009-.011.015l-2.533,4.433c0,.006,0,.012-.006.017a.623.623,0,0,0-.065.175s0,.008,0,.012h0a.627.627,0,0,0-.011.109.618.618,0,0,0,.006.062c0,.012,0,.024,0,.036a.625.625,0,0,0,.051.17c0,.009.009.017.014.026a.633.633,0,0,0,.111.155l8.866,8.866a.635.635,0,0,0,.08.066l.014.012a.621.621,0,0,0,.149.072l.036.011h0a.566.566,0,0,0,.336,0l.036-.011a.623.623,0,0,0,.149-.072l.014-.012a.63.63,0,0,0,.081-.066l8.866-8.866a.633.633,0,0,0,.111-.155c0-.009.01-.017.014-.026a.625.625,0,0,0,.051-.17Zm-15.791-3.311,1.658,2.579H39.211Zm6.589-.587,2.036,3.167H44.663l2.036-3.167Zm1.506,0h3.38l-1.69,2.629Zm.761,4.433-2.554,6.5-2.554-6.5Zm-6.037-1.8-1.69-2.629h3.38Zm-.432,1.8,2.215,5.637L39.648,305.7Zm7.83,0h3.423l-5.637,5.637Zm.728-1.267,1.658-2.579,1.474,2.579Z",
    transform: "translate(0 -258.067)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12276",
    "data-name": "Path 12276",
    d: "M563.133,40.665a.633.633,0,0,0,.633-.633v-1.9a.633.633,0,1,0-1.267,0v1.9a.633.633,0,0,0,.633.633Z",
    transform: "translate(-516.147)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12277",
    "data-name": "Path 12277",
    d: "M320.277,96.182a.633.633,0,0,0,.9-.9l-.95-.95a.633.633,0,0,0-.9.9Z",
    transform: "translate(-276.905 -55.702)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12278",
    "data-name": "Path 12278",
    d: "M750.642,96.363a.631.631,0,0,0,.448-.186l.95-.95a.633.633,0,0,0-.9-.9l-.95.95a.633.633,0,0,0,.448,1.081Z",
    transform: "translate(-700.49 -55.698)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.d0d33173394fdb4d2cc99c82a6c78559.svg";
export { ForwardRef as ReactComponent };